var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Show,{attrs:{"id":_vm.id,"title":_vm.title,"realm":"us"}})
}
var staticRenderFns = []

export { render, staticRenderFns }